import React, { FC, useContext } from 'react'
import { Token } from '../../logic/token/token'
import { usePools } from '../../hooks/use-pools'
import styled from 'styled-components'
import { swaapPurple0, swaapPurple2 } from '../Themes'
import { LargeCurrencyLogo } from '../CurrencyLogo'
import CurrencyLogo from '../CurrencyLogo'
import { coinImage } from '../../assets/coins/coins'
import { TokenWithData } from '../../api/api-types'
import {
  PoolComposition,
  PoolCompositions,
  PoolCompositionSymbol,
  PoolCompositionWeight,
  PoolCompositionLogoSymbol,
} from './PoolComposition'
import CurrencyValue from '../CurrencyValue'
import { SimpleLoader } from '../catalog/SwaapLoader'
import PercentageValue from '../PercentageValue'
import { EmptyCell } from '../catalog/EmptyCell'
import { Web3Context } from '../../hooks/web3'
import { Rewards } from '../catalog/Rewards'
import { NetAPR } from '../catalog/MouseoverLegend'
import { createEarnTabEvent } from 'user-events-segment'

interface Props {
  enableUser: boolean
}
export const PoolMobileView: FC<Props> = ({ enableUser }) => {
  const { pools, loading, userSharesLoaded } = usePools()
  const { isConnectedToWeb3, web3, account } = useContext(Web3Context)
  enableUser = enableUser && isConnectedToWeb3

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {pools.map(line => {
        return (
          <Card key={line.pool.address}>
            <Line>
              <PoolCompositions>
                {line.tokens.map((token: TokenWithData, index: number) => {
                  return (
                    <PoolComposition key={`pool-composition-${index}`}>
                      <PoolCompositionLogoSymbol key={`logo-symbol-${index}`}>
                        <LargeCurrencyLogo
                          key={`logo-${index}`}
                          src={coinImage(token['symbol'])!}
                        />
                        <PoolCompositionSymbol
                          key={`pool-composition-symbol-${index}`}
                        >
                          {token['symbol']}
                        </PoolCompositionSymbol>
                      </PoolCompositionLogoSymbol>
                      <PoolCompositionWeight
                        key={`pool-composition-weight-${index}`}
                      >
                        {Math.round(token.percent)}%
                      </PoolCompositionWeight>
                    </PoolComposition>
                  )
                })}
              </PoolCompositions>
            </Line>

            <Line>
              <LabelValue>
                <Label>My invest</Label>
                <div>
                  {!enableUser ? (
                    <EmptyCell />
                  ) : userSharesLoaded ? (
                    <CurrencyValue
                      precision={3}
                      currency="$"
                      value={line.userValue || 0}
                    />
                  ) : isConnectedToWeb3 ? (
                    <SimpleLoader />
                  ) : (
                    ''
                  )}
                </div>
              </LabelValue>
              <LabelValue>
                <Label>TVL</Label>
                <CurrencyValue
                  precision={3}
                  currency="$"
                  value={line.tvl ? line.tvl : 0}
                />
              </LabelValue>
            </Line>

            <Line>
              {/* <LabelValue>
                <Label>Volume (24h)</Label>
                <div>
                {pool.dailyVolume == undefined ? (
                  <span>
                    {' '}
                    <SimpleLoader />{' '}
                  </span>
                ) : (
                  <CurrencyValue
                    precision={3}
                    currency="$"
                    value={pool.dailyVolume}

                  />
                )}
                </div>
              </LabelValue> */}
              <LabelValue>
                <div
                  onMouseOver={() =>
                    createEarnTabEvent(line.pool).hover_net_apr_tooltip('start')
                  }
                  onMouseOut={() =>
                    createEarnTabEvent(line.pool).hover_net_apr_tooltip('end')
                  }
                >
                  <NetAPR>
                    <Label>
                      Net APR{' '}
                      <span
                        style={{
                          fontSize: '0.75rem',
                          padding: '0px 3px 0px 2px',
                        }}
                      >
                        (since inception)
                      </span>
                    </Label>
                  </NetAPR>
                </div>
                <div>
                  {line.net_apr_since_inception == undefined ? (
                    <span>
                      <SimpleLoader />
                    </span>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                    >
                      <PercentageValue value={line.net_apr_since_inception} />
                      <span style={{ height: '0.2rem' }}> </span>
                      <div
                        onMouseOver={() => {
                          createEarnTabEvent(line.pool).hover_swaap_coins_tip(
                            'start'
                          )
                        }}
                        onMouseOut={() => {
                          createEarnTabEvent(line.pool).hover_swaap_coins_tip(
                            'end'
                          )
                        }}
                      >
                        <Rewards />
                      </div>
                    </div>
                  )}
                </div>
              </LabelValue>
            </Line>
          </Card>
        )
      })}
    </div>
  )
}

const Card = styled.div`
  max-width: 90%;
  align-self: center;
  padding: 1.25rem 2.5rem 1.25rem 2.5rem;
  background: ${({ theme }) => theme.poolPanelBackgroundColor};
  box-shadow: ${({ theme }) => theme.poolPanelBowShadowMobile};
  border-radius: 50px;
`

const LabelValue = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  justify-items: center;
  border-radius: 40px;
`

const Line = styled.div`
  display: flex;
  font-size: 2rem;
  padding: 5px;
  align-self: center;
  justify-content: center;
`

const Label = styled.span`
  font-family: Montserrat-Light;
  font-size: 1.15rem;
`
